module.exports = require(`./${process.env.REACT_APP_CONFIG || 'config-live'}.js`)



// WEBPACK FOOTER //
// ./src/config/index.js